<template>
  <button
    @click="$emit('confirm-delete')"
    class="
      relative
      inline-flex
      items-center
      justify-center
      overflow-hidden
      text-sm
      font-medium
      text-gray-900
      rounded-lg
      border border-red-500
      bg-transparent
      group
      focus:ring-4
      focus:outline-none
      focus:ring-red-300
      dark:focus:ring-red-800
      hover:bg-red-500 hover:text-white
      transition-all
      duration-200
      ease-in-out
    "
  >
    <span
      class="
        relative
        px-3
        py-1
        transition-all
        duration-75
        ease-in
        rounded-md
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5 text-red-500 group-hover:hidden"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
      <span class="hidden group-hover:block">Удалить {{this.title}}</span>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'элемент',
    },
  },
  emits: ['confirm-delete'],
};
</script>
